import { CoordinatorService } from './coordinator.service';
import { inject } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { FirebaseFirestore } from './firebase-firestore';
import { FirebaseStorage } from './firebase-storage';
import { getAuth, signInWithCustomToken } from 'firebase/auth';

import { interval } from 'rxjs';
import { httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { Functions } from '@angular/fire/functions';
import { Auth } from '@angular/fire/auth';

export class Firebase$ {
    private _app: FirebaseApp;
    private _functions: Functions;
    private _auth: Auth;
    firestore = new FirebaseFirestore(this);
    storage = new FirebaseStorage(this);

    // syncInterval$ = interval(15000)
    syncInterval$ = interval(1000);

    constructor(public coords: CoordinatorService) {
        this._app = inject(FirebaseApp);
        this._functions = inject(Functions);
        this._auth = inject(Auth);
        // if (this.coords.isLocal) {
        //     connectFunctionsEmulator(this._functions, "localhost", 5001)
        // }
    }

    get firebaseProjectId(): string {
        // Make sure Firebase is initialized before calling this function
        const config = this._app.options;
        return config.projectId as string;
    }

    onStart() {
        this.coords.user$.onStart();
    }

    async customTokenLogin(tkn: string) {
        const u = await signInWithCustomToken(this._auth, tkn);

        localStorage.setItem('extId', u.user.uid);
        localStorage.setItem('extT', Date.now().toString());
        this.coords.display$.closeDialog();
        return u;
    }

    async httpFunction(fName: string) {
        const resp = httpsCallable(this._functions, fName)();
        return resp;
    }
    async callFunction(fName: string, data: any) {
        try {
            data = data || {};
            data.referer = window.location.hostname;
            const f = httpsCallable(this._functions, fName);
            const resp = await f(data);
            return resp;
        } catch (e) {
            console.error('fb$.callFunction', fName, e);
            return 'ERROR';
        }
    }

    get projectId() {
        return this.coords.project$.currentId;
    }

    get userId() {
        const userId = this.coords.user$.currentId;
        if (!userId) {
            console.warn('No user id found.');
            return undefined;
        }
        return userId;
    }
}
